import React, {Component} from 'react';

export default class Tabs extends Component {
    state = {
        active: 0
    }

    renderHeaders = () => {
        return this.props.tabs.map((item, index) => (
            <li className={this.state.active === index ? 'active' : ''} key={index}>
                <a href={window.location.href} onClick={() => this.setState({ active: index })}>
                    {item.headers.title}
                </a>
            </li>
        ))
    }
    render() {
        return (
            <div className="nav-tabs-custom">
                <ul className="nav nav-tabs">
                    {this.renderHeaders()}
                </ul>

                <div className="tab-content">
                    <div className="tab-pane active">
                        {this.props.tabs[this.state.active].body}
                    </div>
                </div>
            </div>
        );
    }
}